import React, { memo, useState } from 'react';
import { TouchableOpacity, View } from 'react-native';
import {
  WebScrollView,
  LoadingContainer,
  Space,
  Text,
  PanelCompatibleContainer,
} from '@redlink/components/atoms';
import { createUseStyle } from '@redlink/assets/styles';
import { useMutation, editPageLanguageQuery } from '@redlink/services';
import { useLocale } from '@redlink/assets/locale';
import { useValues } from '@redlink/assets/values';
import { SetupPageTitle, Button } from '@redlink/components/molecules';
import { useNavigation, StackActions } from '@react-navigation/native';

const languages = [
  { id: 'fa', value: 'فارسی' },
  { id: 'en', value: 'English' },
];

export const PageLanguageSetupPage = memo(({ navigation }) => {
  const { styles } = useStyle();
  const { dictionary } = useLocale();
  const { routes } = useValues();
  const [pageLanguage, setPageLanguage] = useState(languages[0].id);
  const { dispatch: navigationDispatch } = useNavigation();

  const [edit, { loading }] = useMutation(editPageLanguageQuery, {
    done: () =>
      navigationDispatch(StackActions.replace(routes.pageNameSetup.key)),
  });

  return (
    <LoadingContainer isBusy={loading} style={styles.container}>
      <WebScrollView>
        <PanelCompatibleContainer>
          <SetupPageTitle
            title={dictionary.setupPageTitle}
            subtitle={dictionary.setupPageLanguageTitle}
            description={dictionary.setupPageLanguageDescription}
            step={0}
          />
          <Space size={32} />
          <LanguageSelect
            selectedLanguage={pageLanguage}
            onChange={(item) => setPageLanguage(item.id)}
          />
          <Space size={32} />
          <Button
            style={styles.formActionContainer}
            title={dictionary.continue}
            variant="primary"
            onPress={() => {
              edit({
                language: pageLanguage,
              });
            }}
          />
        </PanelCompatibleContainer>
      </WebScrollView>
    </LoadingContainer>
  );
});

const LanguageSelect = memo(({ selectedLanguage, onChange }) => {
  const { styles } = useStyle();
  return (
    <View style={styles.languagesContainer}>
      {languages.map((item, index) => {
        const selected = item.id === selectedLanguage;
        return (
          <TouchableOpacity
            activeOpacity={0.7}
            style={[
              styles.languageContainer,
              selected && styles.languageContainerSelected,
            ]}
            onPress={() => onChange(item)}
          >
            <Text
              en={item.id === 'en'}
              style={[
                styles.languageTitle,
                selected && styles.languageTitleSelected,
              ]}
            >
              {item.value}
            </Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    flex: 1,
    backgroundColor: colors.white,
  },
  languagesContainer: {
    gap: 10,
    flexDirection: 'row',
  },
  languageContainer: {
    flex: 1,
    borderWidth: 1,
    borderColor: colors.blue8,
    backgroundColor: colors.blue8,
    borderRadius: 40,
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  languageContainerSelected: {
    borderColor: colors.blue1,
    backgroundColor: colors.blue1,
  },
  languageTitle: {
    color: colors.black,
    textAlign: 'center',
    fontSize: 16,
  },
  languageTitleSelected: {
    color: colors.white,
  },
  formActionContainer: {
    minHeight: 50,
  },
}));
